export type WorldEffect =
  | { type: 'pop'; id: string }
  | { type: 'shell-pop'; id: string }
  | { type: 'energy'; id: string; amount: number }
  | { type: 'selection' }
  | { type: 'debug-ghost' }
  | { type: 'debug-live' };

const listeners = new Set<(effect: WorldEffect) => void>();

export function emitWorldEffect(effect: WorldEffect): void {
  for (const listener of listeners) listener(effect);
}

export function onWorldEffect(listener: (effect: WorldEffect) => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
